module.exports = __webpack_public_path__ + "img/busca-forestal.32e11ad5.jpg";